import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {AArticleDetail} from "@/components/popup/articleDetail/AArticleDetail";
import MUploadimg from "@/components/module/MUploadimg";
import MTextarea from "@/components/module/MTextarea";
import {ExtEdit} from "@/classes/ext/ext-edit";

@Component({
    components: {
        MUploadimg,
        MTextarea,
    }
})
export default class Gallery extends AArticleDetail {
    public get extEdit(): ExtEdit {
        return new ExtEdit(this);
    }

    public async onInput(e: any) {
        await this.extEdit.onInput(e);
    }
}
